import { xss, xssEscapeHtml, xssStrip } from '@/utils/xss';

function sanitizeHtml(el, binding) {
  if (binding.value !== binding.oldValue) {
    if (Array.isArray(binding.value)) {
      // no-dd-sa:javascript-browser-security/inner-outer-html
      el.innerHTML = xss(binding.value[1], binding.value[0]);
    } else if (binding.modifiers.strip) {
      // no-dd-sa:javascript-browser-security/inner-outer-html
      el.innerHTML = xssStrip(binding.value);
    } else if (binding.modifiers.escape) {
      // no-dd-sa:javascript-browser-security/inner-outer-html
      el.innerHTML = xssEscapeHtml(binding.value);
    } else {
      // no-dd-sa:javascript-browser-security/inner-outer-html
      el.innerHTML = xss(binding.value);
    }
  }
}

export default sanitizeHtml;
